module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "button is-medium is-primary",
    attrs: {
      "aria-controls": "contentIdForA11y2"
    },
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_vm._v("\n                Toggle\n            ")])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "panel",
    attrs: {
      "aria-id": "contentIdForA11y2",
      "open": _vm.isOpen
    },
    on: {
      "update:open": function($event) {
        _vm.isOpen = $event
      }
    }
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "slot": "trigger",
      "role": "button",
      "aria-controls": "contentIdForA11y2"
    },
    slot: "trigger"
  }, [_c('strong', [_vm._v("Title")])]), _vm._v(" "), _c('p', {
    staticClass: "panel-tabs"
  }, [_c('a', {
    staticClass: "is-active"
  }, [_vm._v("All")]), _vm._v(" "), _c('a', [_vm._v("Public")]), _vm._v(" "), _c('a', [_vm._v("Private")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_vm._v("\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. "), _c('br'), _vm._v("\n                Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. "), _c('br'), _vm._v("\n                Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.\n            ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c12185"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/collapse/examples/ExPanelTemplate.vue
// module id = 1022
// module chunks = 19 150